import React, { useState } from 'react';

function PurchaseInfo({ setCountry, setRetailer, setPurchaseDate, translations, country, today }) {
  const countries = window._THULEDATA._SalesForceProductRegistration.Countries;

  const [showDateError, setShowDateError] = useState(false);

  return (
    <div className="sfpr__purchaseInfo col-12">
      <span className="heading6">{translations.PurchaseInfo}</span>
      <div>
        <div className="sfpr__inputField col-12">
          <label htmlFor="country">{translations.Country} *</label>
          <select required onChange={(e) => setCountry(e.target.value)} defaultValue={country} id="country">
            {Object.keys(countries).map(function (keyName) {
              return (
                <option value={keyName} key={keyName} id={keyName}>
                  {countries[keyName]}
                </option>
              );
            })}
          </select>
        </div>
        <div className="sfpr__inputField">
          <label htmlFor="retailer">{translations.Store} *</label>
          <input required onChange={(e) => setRetailer(e.target.value)} type="text" id="retailer" />
        </div>
        <div className="sfpr__inputField">
          <label htmlFor="purchaseDate" className="d-inline-block">
            {translations.DateOfPurchase}*
          </label>
          {showDateError && <span className="ms-4 errorMessage">{translations.DateErrorMessage}</span>}
          <input
            max={today}
            required
            onChange={(e) => {
              if (new Date(e.target.value) > new Date(today)) {
                setShowDateError(true);
              } else {
                setShowDateError(false);
              }
              setPurchaseDate(e.target.value);
            }}
            type="date"
            id="purchaseDate"
          />
        </div>
      </div>
    </div>
  );
}
export default PurchaseInfo;
